const specialsRegExp = /[`~!@#$%^&*()_=+\\[\]{};:'",.<>/? -]/;
const incorrectRegExp = /[^a-zA-Z0-9`~!@#$%^&*()_=+\\[\]{};:'",.<>/? -]/;
const incorrectSpaces = /^\s|\s$/;
const specialCharCost = 2;
const minComplexity = 5;
const minPasswordLength = 8;

function calcPasswordComplexity(value: string) {
    return (
        (/\d/.test(value) ? 1 : 0) +
        (/[a-z]/.test(value) ? 1 : 0) +
        (/[A-Z]/.test(value) ? 1 : 0) +
        (specialsRegExp.test(value) ? specialCharCost : 0)
    );
}

export function passwordValidation(value: string) {
    if (!value?.length) return false;

    const lengthRequirement = value.length >= minPasswordLength;
    const complexityRequirement = calcPasswordComplexity(value) >= minComplexity;
    const spaceRequirement = !incorrectSpaces.test(value);
    const symbolsRequirement = !incorrectRegExp.test(value);

    const res =
        lengthRequirement && complexityRequirement && spaceRequirement && symbolsRequirement;

    return res;
}
